export const AUTOCOMPLETE_REFERENCES_DROPDOWNLIST_ITEMS = "AUTOCOMPLETE_REFERENCES_DROPDOWNLIST_ITEMS"